import styled, { css } from 'styled-components';
import { palette } from 'styled-tools';

export const StepNavigation = styled.div`
    display:flex;
    > div:not(:first-child) {
        margin-left: 8px;
    }
`;

const stepNumberCss = css`
    border-radius: 50%;
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const StepNavNumber = styled.div`
    ${stepNumberCss}
    background-color: ${palette('gray_opacity_200')};

`;

export const CurrentContainer = styled.div`
display: flex;
border-radius: 12px;
background-color: ${palette('blue_opacity_100')};
`;

export const CurrentStepNumber = styled.div`
    ${stepNumberCss}
    background-color: ${palette('blue_900')};
`;

export const CurrentStepName = styled.div`
    display: flex;
    align-items: center;
    padding: 0 8px 0 4px;
`;